import React from "react";
//PrimeReact Components
import * as pr from "../../../common/PrimeComponents";
import { ViewState } from "../../../common/config/AppConstants";
import * as format from "../../../common/FormatFunctions";
import { ListValueDisplay } from "../../Common/ListValueDisplay";
import { OrderDisplay } from "../../Orders/UI/OrderDisplay";

export class SelectOrderItems extends React.Component {
  render() {
    if (!format.isNotNull(this.props.selectedOrderItems)) {
      return <div></div>;
    }

    let flaggedColumns = [];
    if (this.props.shipTogether !== true) {
      flaggedColumns.push(
        <pr.Column
          key="quantity"
          field="quantity"
          header="Quantity Remaining"
          style={{ overflow: "auto", backgroundColor: "white" }}
        />
      );
      flaggedColumns.push(
        <pr.Column
          key="add"
          field="shipTogether"
          header="Ship Together?"
          body={this.getOrderItemShipTemplate}
          style={{ textAlign: "center", width: "8em" }}
        />
      );
      flaggedColumns.push(
        <pr.Column
          key="quantityAdded"
          header="Set Quantity"
          field="quantityAdded"
          editor={this.orderItemQuantityEditor}
          style={{ overflow: "auto", backgroundColor: "white" }}
        />
      );
      flaggedColumns.push(
        <pr.Column
          key="add"
          body={this.getOrderItemAddTemplate}
          style={{ textAlign: "center", width: "8em" }}
        />
      );
    } else {
      flaggedColumns.push(
        <pr.Column
          key="quantity"
          field="quantity"
          header="Quantity"
          style={{ overflow: "auto", backgroundColor: "white" }}
        />
      );
    }
    return (
      <div>
        <pr.DataTable
          ref={el => {
            this.dt = el;
          }}
          reorderableColumns={false}
          selectionMode="single"
          onSelectionChange={e => {}}
          value={this.props.selectedOrderItems}
          dataKey="id"
          emptyMessage="This order contains no Products"
          rows={100}
          autoLayout={true}
        >
          <pr.Column
            field="productName"
            header="Name"
            style={{ overflow: "auto", backgroundColor: "white" }}
          />
          <pr.Column
            field="productDescription"
            header="Description"
            style={{ overflow: "auto", backgroundColor: "white" }}
          />

          {flaggedColumns}
        </pr.DataTable>
      </div>
    );
  }

  getOrderItemShipTemplate = rowData => {
    return (
      <div>
        <pr.TriStateCheckbox
          disabled={true}
          onLabel="Yes"
          offLabel="No"
          value={rowData.shipTogether}
        />
      </div>
    );
  };

  onOrderItemBodyValueChange = (row, field, value) => {
    let updatedList = this.props.editedObject.deliveryItemRequestList;
    updatedList.forEach(element => {
      if (element.id === row) {
        element[field] = value;
      }
    });
    let editedObject = this.props.editedObject;
    editedObject.deliveryItemRequestList = updatedList;

    this.props.updateState("editedObject", editedObject);
  };

  orderItemQuantityEditor = props => {
    console.log(props);
    return this.orderItemInputTextEditor(props, "quantityAdded");
  };

  orderItemInputTextEditor = (props, field) => {
    if (props.rowData.shipTogether) {
      return (
        <div className="ui-g-12">
          <label>{props.rowData[field] || ""}</label>
        </div>
      );
    } else {
      return (
        <pr.InputText
          type="text"
          keyfilter="int"
          value={props.rowData[field] || ""}
          onChange={e =>
            this.onOrderItemEditorValueChange(
              props.rowIndex,
              props.field,
              e.target.value
            )
          }
        />
      );
    }
  };

  onOrderItemEditorValueChange = (row, field, value) => {
    let updatedList = this.props.selectedOrderItems;
    updatedList[row][field] = value;

    var selectedOrderItems = updatedList;

    this.props.updateState("selectedOrderItems", selectedOrderItems);
  };

  updateOrderItem = (rowData, field, value) => {
    let updatedList = this.props.selectedOrderItems;
    updatedList.forEach(element => {
      if (element.id === rowData.orderItemId) {
        element[field] = value;
      }
    });

    var selectedOrderItems = updatedList;
    if (field === "added") {
      let editedObject = this.props.editedObject;
      var deliveryItemRequestList = editedObject.deliveryItemRequestList;
      if (format.isNotNull(deliveryItemRequestList)) {
        var index = 0;
        var elementFound = false;
        var deliveryItemRequest = {};
        deliveryItemRequestList.forEach(element => {
          if (!elementFound) {
            if (element.orderItemId === rowData.orderItemId) {
              elementFound = true;
              deliveryItemRequest = element;
              // TODO Check Quantity here
              deliveryItemRequest.quantityAdded = rowData.quantityAdded;
            } else {
              index++;
            }
          }
        });
        if (elementFound) {
          deliveryItemRequestList[index] = deliveryItemRequest;
        } else {
          deliveryItemRequestList.push(rowData);
        }
      } else {
        deliveryItemRequestList = [];
        deliveryItemRequestList.push(rowData);
      }
      editedObject.deliveryItemRequestList = deliveryItemRequestList;
      this.props.updateState("editedObject", editedObject);
    }

    this.props.updateState("selectedOrderItems", selectedOrderItems);
  };

  getOrderItemAddTemplate = (rowData, column) => {
    if (rowData.added) {
      return (
        <div>
          <pr.Button
            type="button"
            icon="pi pi-check"
            className="p-button-success"
            onClick={() => {}}
            // onClick={() => {
            //   this.setState({ partSelected: rowData, partAdded: true });
            // }}
            style={{ marginRight: ".5em", background: "green" }}
          ></pr.Button>
          {/* <pr.Button
            type="button"
            icon="pi pi-"
            className="p-button-success"
            onClick={f => {
              this.updateOrderItem(rowData, "added", false);
            }}
            style={{ marginRight: ".5em" }}
          ></pr.Button> */}
        </div>
      );
    } else {
      return (
        <div>
          <pr.Button
            type="button"
            icon="pi pi-plus"
            className="p-button-success"
            onClick={f => {
              this.updateOrderItem(rowData, "added", true);
            }}
            // onClick={() => {
            //   this.setState({ partSelected: rowData, partAdded: true });
            // }}
            style={{ marginRight: ".5em" }}
          ></pr.Button>
        </div>
      );
    }
  };

  getOrderItemRemoveTemplate = (rowData, column) => {
    return (
      <div>
        <pr.Button
          type="button"
          icon="pi pi-trash"
          className="p-button-success"
          onClick={e => {}}
          style={{ marginRight: ".5em" }}
        ></pr.Button>
      </div>
    );
  };
}



// WEBPACK FOOTER //
// ./src/components/Deliverys/UI/SelectOrderItems.js